import React from 'react';
import WhatsNewModal from './WhatsNewModal';
import useWhatsNewAutoShow from './useWhatsNewAutoShow';
import { whatsNewItems } from './whatsNewConfig';
import { useAuthUser } from '@tenant/utility/AuthHooks';

/**
 * Wrapper component that handles automatic display of WhatsNew modal
 * This component should be placed at the app level to show the modal automatically
 * Only shows to authenticated users
 */
const WhatsNewAutoDisplay = () => {
  const { isAuthenticated } = useAuthUser();
  const { shouldShowAuto, markAsShown } = useWhatsNewAutoShow();

  const handleClose = () => {
    markAsShown();
  };

  // Only show to authenticated users
  if (!isAuthenticated) {
    return null;
  }

  return (
    <WhatsNewModal
      open={shouldShowAuto}
      onClose={handleClose}
      items={whatsNewItems}
    />
  );
};

export default WhatsNewAutoDisplay;
